import { Component } from "react"
import type { EmbeddedBrowserTab } from "../../browser/tab"

type BrowserWebviewProps = {
    tab: EmbeddedBrowserTab
    partition: string
    active: boolean
}

type Attachment = { tab: EmbeddedBrowserTab; host: HTMLDivElement }

export class BrowserWebview extends Component<BrowserWebviewProps> {
    private host: HTMLDivElement | null = null
    private attachment: Attachment | null = null
    private attachmentGeneration = 0

    componentDidMount(): void {
        this.scheduleAttachment()
    }

    componentDidUpdate(previousProps: BrowserWebviewProps): void {
        if (previousProps.tab !== this.props.tab || previousProps.partition !== this.props.partition) this.scheduleAttachment()
    }

    componentWillUnmount(): void {
        this.attachmentGeneration += 1
        const attachment = this.attachment
        this.attachment = null
        if (attachment) queueMicrotask(() => attachment.tab.unmount(attachment.host))
    }

    private readonly setHost = (host: HTMLDivElement | null) => {
        this.host = host
    }

    private scheduleAttachment(): void {
        const host = this.host
        if (!host) return
        const { tab, partition } = this.props
        const generation = ++this.attachmentGeneration
        queueMicrotask(() => {
            if (generation !== this.attachmentGeneration || this.host !== host) return
            this.attachment?.tab.unmount(this.attachment.host)
            tab.mount(host, partition)
            this.attachment = { tab, host }
        })
    }

    render(): JSX.Element {
        return (
            <div
                ref={this.setHost}
                className={`absolute inset-0 overflow-hidden bg-white ${this.props.active ? "opacity-100" : "pointer-events-none opacity-0"}`}
                aria-hidden={!this.props.active}
            />
        )
    }
}
